import { render, staticRenderFns } from "./TheStatus.vue?vue&type=template&id=6c64b074&scoped=true"
import script from "./TheStatus.vue?vue&type=script&lang=ts"
export * from "./TheStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c64b074",
  null
  
)

export default component.exports